import graphql__dfacbeb11ce3c6d24505 from "./__generated__/ContributorContactRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributorContactModal from "../Contributions/ContributorContact/ContributorContactModal";
import ModalLoader from "../Modals/ModalLoader";
import ModalErrorBoundary from "../ErrorBoundaries/ModalErrorBoundary";

const ContributorContactRoute = props => {
  const { contributionSlug } = useParams();

  return (
    <AppQueryRenderer
      key={contributionSlug}
      query={ContributorContactRouteQuery}
      variables={{ contributionSlug }}
      component={ContributorContactModal}
      additionalProps={props}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
    />
  );
};

const ContributorContactRouteQuery = graphql__dfacbeb11ce3c6d24505;

export default ContributorContactRoute;
